import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Careers() {
  return (
    <>
      <Helmet>
        <title>Careers | Cleaning Jobs Christchurch | Clear &amp; Clean</title>
        <meta
          name="description"
          content="Join the Clear & Clean team in Christchurch. We are hiring reliable cleaning professionals for commercial, industrial and specialist cleaning roles across Canterbury."
        />
        <meta
          name="keywords"
          content="cleaning jobs Christchurch, commercial cleaning careers NZ, Clear and Clean jobs, cleaning company hiring Canterbury, part time cleaning jobs NZ"
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/careers" />
        <meta property="og:title" content="Careers at Clear & Clean | Cleaning Jobs Christchurch" />
        <meta
          property="og:description"
          content="We are hiring reliable cleaning professionals in Christchurch and Canterbury. Send your CV to join the Clear & Clean team."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clearandclean.co.nz/careers" />
        <meta property="og:image" content="https://www.clearandclean.co.nz/images/career_banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers at Clear & Clean | Cleaning Jobs Christchurch" />
        <meta
          name="twitter:description"
          content="We are hiring reliable cleaning professionals in Christchurch. Join the Clear & Clean team today."
        />
        {/* BreadcrumbList */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",    "item": "https://www.clearandclean.co.nz/" },
              { "@type": "ListItem", "position": 2, "name": "Careers", "item": "https://www.clearandclean.co.nz/careers" }
            ]
          }
        `}</script>

        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "JobPosting",
            "title": "Commercial Cleaning Professional",
            "description": "Clear & Clean is hiring reliable and motivated cleaning professionals for commercial, industrial and specialist cleaning roles across Christchurch and Canterbury.",
            "hiringOrganization": {
              "@type": "Organization",
              "name": "Clear & Clean",
              "sameAs": "https://www.clearandclean.co.nz"
            },
            "jobLocation": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Christchurch",
                "addressRegion": "Canterbury",
                "addressCountry": "NZ"
              }
            },
            "employmentType": "FULL_TIME",
            "datePosted": "2025-01-01",
            "validThrough": "2026-12-31",
            "applicationContact": {
              "@type": "ContactPoint",
              "email": "info@clearandclean.co.nz"
            }
          }
        `}</script>
      </Helmet>

      {/* Hero */}
      <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: 'url("images/career_banner.jpg")' }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 ftco-animate pb-5">
              <p className="breadcrumbs mb-2">
                <span className="mr-2">
                  <Link to="/">Home <i className="fa fa-chevron-right" /></Link>
                </span>
                <span>Careers <i className="fa fa-chevron-right" /></span>
              </p>
              <h1 className="mb-0 bread">Careers at Clear &amp; Clean</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center pb-4">
            <div className="col-md-8 text-center ftco-animate">
              <span className="subheading">Join Our Team</span>
              <h2>Work With Clear &amp; Clean in Christchurch</h2>
              <p className="mt-3" style={{ color: "#666", fontSize: "16px", lineHeight: "1.8" }}>
                At Clear &amp; Clean, we are always looking for reliable, hardworking, and motivated
                individuals to join our professional cleaning team across Christchurch and Canterbury.
                We believe in maintaining high service standards and creating a positive, supportive
                working environment where every team member is valued.
              </p>
              <p style={{ color: "#666", fontSize: "16px", lineHeight: "1.8" }}>
                Whether you have experience in commercial cleaning, industrial environments, or
                specialist services — or you are new to the industry and eager to learn — we would
                love to hear from you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join + What We Look For */}
      <section className="ftco-section bg-light pt-4">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-10">
              <div className="row">

                {/* What We Look For */}
                <div className="col-md-6 mb-4">
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #eee",
                      borderRadius: "8px",
                      padding: "2rem",
                      height: "100%"
                    }}
                  >
                    <h3 className="mb-4" style={{ fontSize: "20px" }}>What We Look For</h3>
                    <ul className="list-unstyled" style={{ fontSize: "15px", lineHeight: "2" }}>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Reliable and punctual</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Strong attention to detail</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Ability to work independently</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Good communication skills</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Commitment to workplace safety</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Respectful and professional attitude</li>
                      <li><i className="fa fa-check-circle mr-2" style={{ color: "#28a745" }}></i> Valid NZ work rights</li>
                    </ul>
                  </div>
                </div>

                {/* Why Work With Us */}
                <div className="col-md-6 mb-4">
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #eee",
                      borderRadius: "8px",
                      padding: "2rem",
                      height: "100%"
                    }}
                  >
                    <h3 className="mb-4" style={{ fontSize: "20px" }}>Why Work With Us</h3>
                    <ul className="list-unstyled" style={{ fontSize: "15px", lineHeight: "2" }}>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> Competitive hourly rates</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> Flexible working hours</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> Supportive team environment</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> On-the-job training provided</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> Opportunities to grow within the company</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> Work across Christchurch and Canterbury</li>
                      <li><i className="fa fa-star mr-2" style={{ color: "#f5a623" }}></i> All equipment and supplies provided</li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Roles Available */}
          <div className="row justify-content-center mb-5">
            <div className="col-md-10">
              <h3 className="mb-4 text-center" style={{ fontSize: "20px" }}>Roles We Hire For</h3>
              <div className="row text-center">
                {[
                  { icon: "fa-building", label: "Office &amp; Workplace Cleaning" },
                  { icon: "fa-industry", label: "Industrial &amp; Warehouse Cleaning" },
                  { icon: "fa-shopping-bag", label: "Retail &amp; Showroom Cleaning" },
                  { icon: "fa-medkit", label: "Healthcare &amp; Medical Cleaning" },
                  { icon: "fa-graduation-cap", label: "School &amp; Education Cleaning" },
                  { icon: "fa-home", label: "Common Area &amp; Facility Cleaning" },
                ].map((role, i) => (
                  <div className="col-md-4 col-6 mb-4" key={i}>
                    <div
                      style={{
                        background: "#fff",
                        border: "1px solid #eee",
                        borderRadius: "8px",
                        padding: "1.5rem 1rem"
                      }}
                    >
                      <i className={`fa ${role.icon} fa-2x mb-3`} style={{ color: "#1a73e8" }}></i>
                      <p
                        style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}
                        dangerouslySetInnerHTML={{ __html: role.label }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* How to Apply */}
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  padding: "2.5rem 2rem"
                }}
              >
                <h3 className="mb-3" style={{ fontSize: "22px" }}>How to Apply</h3>
                <p style={{ color: "#666", fontSize: "15px", lineHeight: "1.8" }}>
                  To apply, please send your CV and a short introduction about yourself to our
                  team. Let us know which type of cleaning work you are interested in and your
                  availability. We review all applications and will contact you if a suitable
                  opportunity is available.
                </p>
                <p className="mt-4" style={{ fontSize: "16px" }}>
                  <i className="fa fa-envelope mr-2" style={{ color: "#1a73e8" }}></i>
                  <a href="mailto:info@clearandclean.co.nz" style={{ fontWeight: "600" }}>
                    info@clearandclean.co.nz
                  </a>
                </p>
                <p style={{ fontSize: "15px", color: "#666" }}>
                  We look forward to hearing from you.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Careers;
